// extracted by mini-css-extract-plugin
export var box = "_78-1";
export var checked = "_78-2";
export var descriptionSpacer = "_78-9";
export var disabled = "_78-3";
export var icon = "_78-6";
export var input = "_78-0";
export var labelSpacer = "_78-8";
export var medium = "_78-5";
export var small = "_78-4";
export var text = "_78-7";